import * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../../App'
import GridItem from '../../grid/GridItem'
import GridContainer from '../../grid/GridContainer'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import MaterialTable from 'material-table'
import download from 'downloadjs'
import { createDateFromString } from '../../utils/DateUtils'
import { getApiUrl } from '../../../api/api'

const columns = [
  { field: 'tenantFullName', title: 'Name' },
  {
    field: 'tenantEmail',
    title: 'Email',
    render: (rowData) => <a href={`mailto:${rowData.tenantEmail}`}> {rowData.tenantEmail} </a>,
  },
  { field: 'tenantRoom', title: 'Zimmer' },

  {
    field: 'departureDate',
    title: 'Auszug',
    customSort: (a, b) => createDateFromString(a.departureDate) - createDateFromString(b.departureDate),
    defaultSort: 'desc',
  },
]

export default function CompletedDepartureTable() {
  const { user } = useContext(UserContext)

  const [proceeding, setProceeding] = useState(true)

  const [departures, setDepartures] = useState([])

  useEffect(() => {
    getApiUrl({ status: 'CLOSED' })
      .get(`/admin/departures`)
      .then(function(response) {
        setProceeding(false)
        setDepartures(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [user])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={departures}
          title=""
          actions={[
            {
              icon: 'download',
              tooltip: 'Laufzettel herunterladen',
              onClick: (event, rowData) => {
                getApiUrl()
                  .get(`/admin/departures/${rowData.departureId}/pdf`, {
                    headers: { Authorization: `Bearer ${user.token}`, 'X-Smartdorm-Dorm-ID': '4885b6d1-bbe4-4d40-bd24-bce33f0d7728' },
                    responseType: 'blob',
                  })
                  .then((response) => {
                    const content = response.headers['content-type']
                    download(response.data, `Laufzettel ${rowData.tenantFullName}`, content)
                  })
                  .catch((error) => console.log(error))
                event.stopPropagation()
              },
            },
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontWeight: 600,
            },
          }}
          localization={{
            header: {
              actions: 'Aktion',
            },
            pagination: {
              labelDisplayedRows: '{from}-{to} von {count}',
              labelRowsSelect: 'Einträge',
              labelRowsPerPage: 'Zeilen pro Seite',
            },
            toolbar: {
              nRowsSelected: '{0} Zeile(n) ',
              searchPlaceholder: 'Suchen',
              searchTooltip: 'Suchen',
            },
            body: {
              emptyDataSourceMessage: 'Keine Daten vorhanden.',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
        />
      </GridItem>
    </GridContainer>
  )
}
